import { useEffect } from "react";
import SEOHead from "@/components/SEOHead";
import Layout from "@/components/Layout";
import { getActiveVariant } from "@/lib/seo-experiments";
import { trackEvent } from "@/lib/tracking";
import HeroSection from "@/components/HeroSection";
import TrustSection from "@/components/TrustSection";
import ProductWorldsSection from "@/components/ProductWorldsSection";
import ProductSpotlightSection from "@/components/ProductSpotlightSection";
import SelectionGuideSection from "@/components/SelectionGuideSection";
import ExperienceSection from "@/components/ExperienceSection";
import HowToSection from "@/components/HowToSection";
import CashbackDiscountSection from "@/components/CashbackDiscountSection";
import FAQSection from "@/components/FAQSection";
import FinalCTASection from "@/components/FinalCTASection";
import ExpertSection from "@/components/ExpertSection";
import DisclosureSection from "@/components/DisclosureSection";

const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Gibt es aktuell einen heilys Rabattcode?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ja, aktuell ist der heilys Rabattcode LONGEVITY verfügbar. Mit diesem Code erhalten Nutzer nach aktuellem Stand 5 % Rabatt auf das gesamte heilys Sortiment. Der Code kann direkt im Checkout des offiziellen heilys Shops eingelöst werden.",
      },
    },
    {
      "@type": "Question",
      name: "Wie funktioniert der Code LONGEVITY?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Kopiere den Code LONGEVITY, öffne den heilys Shop über den Partnerlink und lege deine gewünschten Produkte in den Warenkorb. Im Checkout-Bereich gibt es ein Feld für Rabattcodes – dort fügst du LONGEVITY ein und der Rabatt wird automatisch abgezogen.",
      },
    },
    {
      "@type": "Question",
      name: "Für welche Produkte gilt der Rabatt?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Nach aktuellem Stand gilt der heilys Rabattcode LONGEVITY für das gesamte Sortiment im offiziellen heilys Shop – also für Rotlichtpanels, kompakte Lampen, Wearables und Zubehör.",
      },
    },
    {
      "@type": "Question",
      name: "Ist heilys.info der offizielle heilys Shop?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Nein. heilys.info ist eine unabhängige Informationsseite und hat keine direkte Verbindung zum Unternehmen heilys. Wir betreiben keinen eigenen Shop und verkaufen keine Produkte.",
      },
    },
    {
      "@type": "Question",
      name: "Welche heilys Produkte sind für Einsteiger interessant?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Für Einsteiger in die Rotlichttherapie für zuhause eignen sich in der Regel kompakte Geräte oder kleinere Panels, da sie einen überschaubaren Einstieg bieten und einfach zu handhaben sind.",
      },
    },
    {
      "@type": "Question",
      name: "Worauf sollte man bei Rotlichtgeräten achten?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Wichtige Faktoren bei der Auswahl eines Rotlichtgeräts sind der geplante Einsatzbereich, die Größe des Geräts, die Flexibilität im Alltag und die Verarbeitungsqualität. Typische Wellenlängen sind 630–660 nm für sichtbares Rotlicht und 810–850 nm für Nahinfrarot.",
      },
    },
    {
      "@type": "Question",
      name: "Wie lange ist der Rabattcode gültig?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Der Code LONGEVITY ist nach aktuellem Stand aktiv und funktionsfähig. Eine feste Angabe zur Gültigkeitsdauer können wir als unabhängige Informationsseite nicht garantieren, da die Laufzeit vom Anbieter heilys festgelegt wird.",
      },
    },
    {
      "@type": "Question",
      name: "Lässt sich der Code mit anderen Aktionen kombinieren?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ob der Code LONGEVITY mit anderen Rabattaktionen oder Gutscheinen kombiniert werden kann, hängt von den aktuellen Bedingungen im heilys Shop ab. Wir empfehlen, den Code im Checkout einzugeben und zu prüfen, ob er mit laufenden Aktionen kompatibel ist.",
      },
    },
    {
      "@type": "Question",
      name: "Wie schnell liefert heilys nach Deutschland, Österreich und in die Schweiz?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "heilys versendet nach aktuellem Stand aus Deutschland, wodurch Lieferungen innerhalb Deutschlands in der Regel innerhalb weniger Werktage eintreffen. Für Österreich und die Schweiz kann die Lieferzeit je nach Versandart etwas länger ausfallen.",
      },
    },
    {
      "@type": "Question",
      name: "Was ist der Unterschied zwischen Rotlicht und Nahinfrarot bei heilys Geräten?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sichtbares Rotlicht (630–660 nm) wird für oberflächennahe Anwendungen wie Haut und Gesicht genutzt. Nahinfrarotlicht (810–850 nm) dringt tiefer ins Gewebe ein und wird für Muskeln, Gelenke und tieferliegende Strukturen eingesetzt. Viele heilys Geräte kombinieren beide Wellenlängen.",
      },
    },
    {
      "@type": "Question",
      name: "Gibt es heilys Cashback oder einen Discount-Code?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ein klassisches Cashback-Programm bietet heilys nach aktuellem Stand nicht an. Stattdessen ist der Rabattcode LONGEVITY verfügbar, der 5 % Rabatt auf das gesamte Sortiment im heilys Shop gewährt. Der Code funktioniert wie ein Discount-Code und wird direkt im Checkout eingelöst – die Ersparnis wird sofort vom Bestellwert abgezogen.",
      },
    },
    {
      "@type": "Question",
      name: "Wie sind die heilys Gen30 Erfahrungen?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Das heilys Gen30+Vision ist ein kompaktes Rotlichtgerät mit 36 Dual-Chip-LEDs, 30 W und sechs Wellenlängen (630, 660, 670, 810, 830, 850 nm). Erste Erfahrungen mit dem Gen30 fallen positiv aus – besonders gelobt werden der Vision-Modus mit 670 nm (laut Hersteller ohne Schutzbrille nutzbar), die kompakte Bauform für gezielte Anwendungen sowie die niedrigen EMF-Werte und der flimmerfreie Betrieb. Für Ganzkörperanwendungen sind größere heilys Panels besser geeignet.",
      },
    },
    {
      "@type": "Question",
      name: "Heißt es heilys oder hailys?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Die korrekte Schreibweise der Marke ist heilys (mit „ei\"). Häufige Tippfehler wie „hailys\", „heylis\" oder „heilis\" beziehen sich in der Regel auf dieselbe Marke der weCare+ GmbH aus Bielefeld. Auf heilys.info nutzen wir konsequent die offizielle Schreibweise heilys.",
      },
    },
  ],
};

const howToStructuredData = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "So löst du den heilys Rabattcode LONGEVITY ein",
  description:
    "In 4 einfachen Schritten den heilys Rabattcode LONGEVITY einlösen und 5 % Rabatt auf das gesamte Sortiment erhalten.",
  step: [
    {
      "@type": "HowToStep",
      name: "Code kopieren",
      text: "Kopiere den Rabattcode LONGEVITY – klicke einfach auf den Code-Button auf dieser Seite.",
    },
    {
      "@type": "HowToStep",
      name: "heilys Shop öffnen",
      text: "Öffne den offiziellen heilys Shop über den Partnerlink auf dieser Seite.",
    },
    {
      "@type": "HowToStep",
      name: "Produkte in den Warenkorb legen",
      text: "Wähle deine gewünschten heilys Produkte aus und lege sie in den Warenkorb.",
    },
    {
      "@type": "HowToStep",
      name: "Code im Checkout einlösen",
      text: "Gib den Code LONGEVITY im Rabattcode-Feld im Checkout ein – der Rabatt von 5 % wird automatisch abgezogen.",
    },
  ],
};

const websiteStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "heilys.info",
  url: "https://heilys.info/",
  description:
    "Unabhängige Informationsseite mit dem aktuellen heilys Rabattcode & Influencer Code LONGEVITY für 5 % Rabatt sowie einer neutralen Übersicht zum heilys Sortiment und Gutscheincode.",
  inLanguage: "de",
};

const webPageStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "heilys Rabattcode & Rotlichttherapie-Discount – 5 % mit LONGEVITY",
  url: "https://heilys.info/",
  description:
    "Aktueller heilys Rabattcode LONGEVITY für 5 % Rotlichttherapie-Discount. Cashback-Alternative, Gen30 Erfahrungen und unabhängige Übersicht zum heilys Sortiment.",
  dateModified: "2026-05-01",
  inLanguage: "de",
  isPartOf: { "@type": "WebSite", url: "https://heilys.info/" },
};

const articleStructuredData = {
  "@context": "https://schema.org",
  "@type": "Article",
  headline: "heilys Rabattcode & Rotlichttherapie-Discount: 5 % mit LONGEVITY",
  description:
    "Aktueller heilys Rabattcode LONGEVITY für 5 % Rotlichttherapie-Discount – inkl. Cashback-Alternative, Gen30+Vision-Einordnung, Trustpilot-Score und unabhängiger Produktübersicht.",
  image: "https://heilys.info/images/hero-main.webp",
  datePublished: "2026-01-15",
  dateModified: "2026-05-01",
  inLanguage: "de",
  mainEntityOfPage: { "@type": "WebPage", "@id": "https://heilys.info/" },
  author: {
    "@type": "Person",
    name: "Benedikt Keck",
    url: "https://www.longevity-hackers.de/about",
  },
  reviewedBy: {
    "@type": "Person",
    name: "Benedikt Keck",
    jobTitle: "Longevity-Experte",
    url: "https://www.longevity-hackers.de/about",
  },
  publisher: {
    "@type": "Organization",
    name: "heilys.info",
    url: "https://heilys.info/",
  },
};

const organizationStructuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "heilys.info",
  url: "https://heilys.info/",
  description:
    "Unabhängige Informationsseite mit dem aktuellen heilys Rabattcode LONGEVITY und neutraler Übersicht zur Marke heilys (Rotlichttherapie-Geräte der weCare+ GmbH, Bielefeld).",
  knowsAbout: [
    "heilys",
    "Rotlichttherapie",
    "Rotlichtgeräte",
    "Nahinfrarot",
    "heilys Gen30+Vision",
    "Longevity",
  ],
  subjectOf: {
    "@type": "Brand",
    name: "heilys",
    description:
      "heilys ist eine deutsche Marke der weCare+ GmbH aus Bielefeld, spezialisiert auf Rotlichttherapie-Geräte – darunter Panels, kompakte Lampen, Wearables und das Gen30+Vision.",
  },
};

const imageObjectStructuredData = {
  "@context": "https://schema.org",
  "@type": "ImageObject",
  contentUrl: "https://heilys.info/images/hero-main.webp",
  url: "https://heilys.info/images/hero-main.webp",
  thumbnailUrl: "https://heilys.info/images/hero-main.webp",
  name: "heilys Rabattcode LONGEVITY – 5 % Rabatt auf Rotlichtgeräte",
  description: "Aktueller heilys Rabattcode & Gutscheincode LONGEVITY für 5 % Rabatt auf das gesamte heilys Sortiment – Rotlichtpanels, Lampen und Wearables.",
  caption: "heilys Rabattcode LONGEVITY – 5 % Rabatt auf das gesamte Sortiment",
  width: "1200",
  height: "800",
  representativeOfPage: "true",
  creditText: "heilys.info",
  copyrightNotice: "© 2026 weCare+ GmbH",
  acquireLicensePage: "https://heilys.info/",
  associatedArticle: {
    "@type": "WebPage",
    url: "https://heilys.info/",
  },
};

const spotlightImage1StructuredData = {
  "@context": "https://schema.org",
  "@type": "ImageObject",
  contentUrl: "https://heilys.info/images/heilys_4.webp",
  name: "heilys Gen30+Vision Gesichtsanwendung",
  description: "heilys Gen30+Vision Rotlichtlampe bei der Gesichtsanwendung – Rabattcode LONGEVITY für 5 % Rabatt",
  caption: "Gezielte Rotlichtanwendung im Gesichtsbereich mit dem heilys Gen30+Vision",
};

const spotlightImage2StructuredData = {
  "@context": "https://schema.org",
  "@type": "ImageObject",
  contentUrl: "https://heilys.info/images/heilys_3.webp",
  name: "heilys Gen30+Vision Rotlichtgerät",
  description: "heilys Gen30+Vision Rotlichtgerät mit kompaktem Design – 5 % Rabatt mit Code LONGEVITY",
  caption: "Das kompakte Gen30+Vision mit 36 Dual-Chip-LEDs",
};

const breadcrumbStructuredData = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://heilys.info/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "heilys Rabattcode LONGEVITY",
      item: "https://heilys.info/#rabattcode",
    },
  ],
};

const personStructuredData = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Benedikt Keck",
  jobTitle: "Longevity-Experte",
  worksFor: {
    "@type": "Organization",
    name: "Longevity Hackers",
    url: "https://www.longevity-hackers.de/",
  },
  url: "https://www.longevity-hackers.de/about",
};

const Index = () => {
  const variant = getActiveVariant();

  useEffect(() => {
    // Logge die aktive SEO-Variante einmal pro Session, damit im Dashboard
    // ablesbar ist, welche Variante in welchem Zeitraum live war.
    trackEvent("seo_variant", `title_${variant.id}`);
  }, [variant.id]);

  return (
  <Layout>
    <SEOHead
      title={variant.title}
      description={variant.description}
      canonical="https://heilys.info/"
      ogImage="https://heilys.info/images/hero-main.webp"
      schemaJson={[faqStructuredData, howToStructuredData, websiteStructuredData, webPageStructuredData, articleStructuredData, organizationStructuredData, breadcrumbStructuredData, imageObjectStructuredData, spotlightImage1StructuredData, spotlightImage2StructuredData, personStructuredData]}
    />
    <HeroSection />
    <TrustSection />
    <ProductWorldsSection />
    <ProductSpotlightSection />
    <SelectionGuideSection />
    <ExperienceSection />
    <HowToSection />
    <CashbackDiscountSection />
    <FAQSection />
    <FinalCTASection />
    <ExpertSection />
    <DisclosureSection />
  </Layout>
  );
};

export default Index;
